module.exports = __webpack_public_path__ + "static/media/search-green.7d5b7094.svg";